import { post, get, put } from 'services/api';
import { enStatusInvite, IInvites } from 'interface/invites';
import { receiveCourse } from './course';
import { toastError } from './toastNotifications';
import { resolveErrorStatus } from 'actionCreators/error';
import { API_V4_BASE_URL } from 'settings';

const receiveInvites = (invites: IInvites) => ({
  type: 'RECEIVE_INVITES',
  invites,
});

const accepetInvite = (hash: string) => ({
  type: 'ACCEPT_INVITE',
  hash,
});

const acceptInvites = () => ({
  type: 'ACCEPT_ALL_INVITES',
});

const refuse = (hash: string) => ({
  type: 'REFUSE_INVITE',
  hash,
});

const changingStatus = (hash: string) => ({
  type: 'CHANGING_STATUS',
  hash,
});

const notChangingStatus = (hash: string) => ({
  type: 'NOT_CHANGING_STATUS',
  hash,
});

const receiveInviteStatus = (inviteStatus: enStatusInvite) => ({
  type: 'RECEIVE_INVITE_STATUS',
  inviteStatus,
});

const receiveErrorInviteStatus = (errorStatus: number) => ({
  type: 'RECEIVE_ERROR_INVITE_STATUS',
  errorStatus,
});

const receiveSuccessInviteStatus = (successStatus: Boolean) => ({
  type: 'RECEIVE_SUCCESS_INVITE_STATUS',
  successStatus,
});

export const acceptCourseInvite = (courseHash: string, id: number) => async (dispatch: Function) => {
  try {
    const response = await post({
      url: `/learner/invites/${courseHash}/${id}`,
      baseURL: API_V4_BASE_URL,
    });
    const course = response.data.data;

    dispatch(receiveCourse(course || []));
    dispatch(receiveSuccessInviteStatus(true));
  } catch (error) {
    const errorStatus: number = resolveErrorStatus(error);
    dispatch(receiveErrorInviteStatus(errorStatus));
  }
};

export const checkInvite = (hash: string) => async (dispatch: Function) => {
  try {
    const { data } = await get({ url: `/learner/invites/${hash}`, baseURL: API_V4_BASE_URL });

    dispatch(receiveInviteStatus(data.data.status as enStatusInvite));
  } catch (error) {
    const errorStatus: number = resolveErrorStatus(error);

    dispatch(receiveErrorInviteStatus(errorStatus));
  }
};

export const fetchAllInvitesData = () => async (dispatch: Function) => {
  try {
    const counter = await get({ url: `/learner/invites/count`, baseURL: API_V4_BASE_URL });
    const invitesList = await get({ url: `/learner/invites`, baseURL: API_V4_BASE_URL });
    dispatch(
      receiveInvites({
        count: counter.data.data,
        invitesList: invitesList.data.data,
      })
    );
  } catch (err) {
    dispatch(toastError('erro ao carregar convites'));
  }
};

export const acceptInvite = (hash: string) => async (dispatch: Function) => {
  try {
    dispatch(changingStatus(hash));
    await put({
      url: `/learner/invites/${hash}`,
      baseURL: API_V4_BASE_URL,
      data: { status: enStatusInvite.ACCEPT },
    });

    dispatch(accepetInvite(hash));
    dispatch(notChangingStatus(hash));
  } catch (err) {
    dispatch(toastError('desculpe, algo deu errado'));
    dispatch(notChangingStatus(hash));
  }
};

export const acceptAllInvites = (invitesList: IInvites['invitesList']) => async (dispatch: Function) => {
  try {
    invitesList.forEach((i) => dispatch(changingStatus(i.hash)));

    await post({ url: `/learner/invites/all`, baseURL: API_V4_BASE_URL });

    dispatch(acceptInvites());
    invitesList.forEach((i) => dispatch(notChangingStatus(i.hash)));
  } catch (err) {
    dispatch(toastError('desculpe, algo deu errado'));
    invitesList.forEach((i) => dispatch(notChangingStatus(i.hash)));
  }
};

export const refuseInvite = (hash: string) => async (dispatch: Function) => {
  try {
    dispatch(changingStatus(hash));

    await put({
      url: `/learner/invites/${hash}`,
      baseURL: API_V4_BASE_URL,
      data: { status: enStatusInvite.REFUSED },
    });

    dispatch(refuse(hash));
    dispatch(notChangingStatus(hash));
  } catch (err) {
    dispatch(toastError('desculpe, algo deu errado'));
    dispatch(notChangingStatus(hash));
  }
};

export const activateInvites = () => () => post({ url: `/learner/invites/all`, baseURL: API_V4_BASE_URL });
